export default __webpack_public_path__ + "static/media/039-rudder-1.59b91e1e.png";